import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  style: {"background-image":"url('/assets/img/onboarding-bg.png')"},
  class: "flex bg-blend-lighten flex-col w-full bg-brand-black my-auto h-full bg-contain bg-top bg-no-repeat"
}
const _hoisted_2 = { class: "flex flex-col mt-auto items-center w-full pb-10" }
const _hoisted_3 = {
  key: 0,
  class: "flex flex-col px-6 space-y-40"
}
const _hoisted_4 = { class: "flex flex-col items-center space-y-14" }
const _hoisted_5 = { class: "flex flex-col space-y-4 w-full items-center" }
const _hoisted_6 = {
  key: 1,
  class: "flex w-full flex-col"
}
const _hoisted_7 = { class: "flex w-full" }
const _hoisted_8 = { class: "flex flex-col w-full px-6 justify-center space-y-8" }
const _hoisted_9 = { class: "flex px-5 w-full justify-center" }
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "flex flex-col w-full items-center space-y-2" }
const _hoisted_12 = { class: "flex m-auto text-white text-2xl font-medium" }
const _hoisted_13 = { class: "flex m-auto text-brand-light-gray text-lg text-center" }
const _hoisted_14 = { class: "flex flex-col px-6 mt-10 space-y-8" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_logo_mark = _resolveComponent("logo-mark")!
  const _component_swiper_slide = _resolveComponent("swiper-slide")!
  const _component_swiper = _resolveComponent("swiper")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, {
        "force-overscroll": false,
        fullscreen: true
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              (!_ctx.over18)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                      _createVNode(_component_logo_mark),
                      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "flex m-auto text-white text-3xl font-medium text-center" }, "To be able to use pineapple you must be 18 or older. ", -1))
                    ]),
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("button", {
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.over18 = true)),
                        class: "flex bg-brand-lime rounded-full px-8 h-14 font-medium text-xl text-brand-black"
                      }, [...(_cache[3] || (_cache[3] = [
                        _createElementVNode("div", { class: "flex m-auto space-x-2.5" }, [
                          _createElementVNode("div", { class: "my-auto pt-0.5" }, " I'm 18+ ")
                        ], -1)
                      ]))])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.over18)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createVNode(_component_swiper, {
                        ref: "swiper",
                        modules: _ctx.swiperModules,
                        "slides-per-view": 1,
                        "auto-height": true,
                        pagination: {
                      el: '.pagination'
                    },
                        onSwiper: _ctx.onSwiper
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.slides, (slide, slideKey) => {
                            return (_openBlock(), _createBlock(_component_swiper_slide, { key: slideKey }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_8, [
                                  _createElementVNode("div", _hoisted_9, [
                                    _createElementVNode("img", {
                                      class: "max-h-fit",
                                      alt: "",
                                      src: slide.image
                                    }, null, 8, _hoisted_10)
                                  ]),
                                  _createElementVNode("div", _hoisted_11, [
                                    _createElementVNode("div", _hoisted_12, _toDisplayString(slide.title), 1),
                                    _createElementVNode("div", _hoisted_13, _toDisplayString(slide.text), 1)
                                  ])
                                ])
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modules", "onSwiper"])
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                      _cache[5] || (_cache[5] = _createElementVNode("div", { class: "flex w-full justify-center items-center" }, [
                        _createElementVNode("div", { class: "pagination flex space-x-3 w-auto" })
                      ], -1)),
                      _createElementVNode("button", {
                        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.next && _ctx.next(...args))),
                        class: "flex bg-brand-lime rounded-full px-8 h-14 font-medium text-xl text-brand-black"
                      }, [...(_cache[4] || (_cache[4] = [
                        _createElementVNode("div", { class: "flex m-auto space-x-2.5" }, [
                          _createElementVNode("div", { class: "my-auto pt-0.5" }, " Next ")
                        ], -1)
                      ]))])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}